import { useState } from 'react'
import { Alert, Box, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import type { ExerciseType } from '@/api/exercises'
import { isDelegateExerciseType } from '@/api/exercises'
import { ExerciseRenderer } from './renderers/ExerciseRenderer'
import { sanitizeForStudent } from './sanitize'

/**
 * Предпросмотр «глазами ученика» прямо в конструкторе.
 *
 * Эталоны вычищаются тем же способом, что и на сервере: иначе учитель видел бы
 * в предпросмотре подсвеченные ответы и не заметил бы, что задание без них
 * нерешаемо.
 */
export function ExercisePreview({ type, content }: { type: ExerciseType; content: Record<string, unknown> }) {
  const { t } = useTranslation()
  const [answers, setAnswers] = useState<Record<string, unknown>>({})

  if (isDelegateExerciseType(type)) {
    return <Alert severity="info">{t('exercises.editor.previewDelegate')}</Alert>
  }

  return (
    <Stack spacing={1}>
      <Typography variant="caption" color="text.secondary">
        {t('exercises.editor.previewHint')}
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Box>
          <ExerciseRenderer
            type={type}
            content={sanitizeForStudent(type, content)}
            answers={answers}
            onChange={setAnswers}
          />
        </Box>
      </Paper>
    </Stack>
  )
}
